module.exports = __webpack_public_path__ + "static/media/customStep1.d6afabf7.png";